import React from "react";
import { ShieldCheckIcon, CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { guaranteeItems } from "../../data/sections";
export function GuaranteeSection() {
  return <section className="bg-white px-5 py-16 sm:py-24" data-id="element-172" data-mp="1kb2hc4j73r8z">
      <div className="mx-auto max-w-3xl text-center" data-id="element-173" data-mp="1k9j0octmne6o">
        <span className="mx-auto grid h-24 w-24 place-items-center rounded-full bg-brand text-cream ring-8 ring-brand-light" data-id="element-174" data-mp="1fbptphki2g5c">
          <ShieldCheckIcon className="h-12 w-12" aria-hidden="true" data-id="element-175" data-mp="1aezip8njyaqs" />
        </span>
        <h2 className="mt-6 font-serif text-[2rem] font-extrabold leading-tight text-ink sm:text-5xl" data-id="element-176" data-mp="15d1r9r5009mr">7-Day Guarantee</h2>
        <p className="mt-4 text-lg leading-relaxed text-ink/80" data-id="element-177" data-mp="11f42uqj1xrkf">
          I want you to be able to explore Reflexology Session Blueprint™ without feeling like you're taking an unnecessary risk. After purchasing, you'll be able to:
        </p>
      </div>

      <ul className="mx-auto mt-8 grid max-w-2xl gap-3 sm:grid-cols-2" data-id="element-178" data-mp="2qszfiar3pk9t">
        {guaranteeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-cream px-4 py-3 text-[17px] font-medium text-ink" data-id="element-179" data-mp="1g427ykup8ne2">
            <CheckIcon className="h-5 w-5 shrink-0 text-brand" strokeWidth={3} aria-hidden="true" data-id="element-180" data-mp="1l1tybafp41g5" />
            {item}
          </li>)}
      </ul>

      <p className="mx-auto mt-8 max-w-2xl text-center text-lg leading-relaxed text-ink/80" data-id="element-181" data-mp="1c2gouhrkncvf">
        If within the first 7 days you decide that the system isn't right for you, you can request a refund according to the purchase terms.{" "}
        <strong className="text-ink" data-id="element-182" data-mp="23wiogqysg7b9">Open it, explore it, and decide for yourself.</strong>
      </p>

      <CTAButton label="Yes! I want to try it risk-free" className="mt-10" data-id="element-183" data-mp="1q0x44x3i2bp6" />
    </section>;
}